export default {
    listagem: {
        titulo_pagina: 'Lista de Valor de resultados',
        novo: 'Criar novo valor',
        habilitado: 'Habilitado',
        desabilitado: 'Desabilitado',
        table: {
            empty: 'Nenhum Valor encontrado',
            nome: 'Nome',
            codigo: 'Código',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Criar novo Valor de Resultado',
            editar: 'Editar Valor de Resultado'
        },
        fields: {
            codigo: {
                label: 'Código',
                description: 'Código do Valor'
            },
            nome: {
                label: 'Nome',
                description: 'Nome do Valor'
            },
            status: {
                label: 'Status',
                description: 'Status ativo ou inativo do Valor'
            },
            botao_salvar : 'Salvar Valor'
        },
        create: {
            success: 'Valor criado com Sucesso!',
            error: 'Error ao criar Valor!'
        },
        update: {
            success: 'Valor editado com Sucesso!',
            error: 'Error ao editar Valor!'
        }
    }
}
